import { StyleSheet } from 'react-native';
import {styleVars} from "../../app-style-vars";

export default StyleSheet.create({
  title: {
    fontSize: styleVars.rem(1.25),
    fontWeight: 'bold',
    marginBottom: styleVars.rem(.5),
    color: '#000',
  },
  titleDisabled: {
    color: styleVars.boschLightGray,
  },
  errorMessage: {
    color: 'red'
  },
  creditLimitRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: styleVars.rem(.5),
  },
  creditLimitTitle: {
    marginRight: 10,
    fontWeight: 'bold',
    textAlign: 'left'
  },
  creditLimitContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingHorizontal: styleVars.rem(.5),
  },

  toggleHeaderContainer: {
    paddingVertical: styleVars.rem(.25),
    paddingHorizontal: styleVars.rem(.5),
  },

  toggleHeader: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  availableCreditLimitValue: {
    fontSize: styleVars.rem(1.125),
    fontWeight: 'bold',
    color: styleVars.boschLightGreen,
  },

  blockedValue: {
    color: styleVars.boschRed,
  },

  containerToggleText: {
    fontSize: styleVars.rem(.875),
    color: styleVars.boschDarkBlue
  },

  toggleDetailsContainer: {},
  toggleDetailsContent: {},

  noAuthText: {
    padding: styleVars.rem(.25),
    textAlign: 'center',
    fontSize: styleVars.rem(.625),
  }
});
